
export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      driverId: null,
      document: null,
      validUntil: '',
      createdAt: '',
      updatedAt: ''
    }
  }
}